import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { type TeamFieldConfig } from "./entity";

export const TeamFieldConfigEntityConfig: HyperEntityConfig<TeamFieldConfig> =
{
  allowApiRead: true,
  allowApiCrud: Roles.AdminsAndManager,

  allowInsertPerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);
    allow([Roles.SuperAdmin, Roles.Admin], {
      team: {
        $is: {
          organization: {
            $id: remult.user!.organizationId!,
          },
        },
      },
    });
    allow(Roles.Manager, (entity) =>
      remult.user!.managingTeams!.includes(entity.teamId),
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperDuperAdmin, true);
    allow([Roles.SuperAdmin, Roles.Admin], {
      team: {
        $is: {
          organization: {
            $id: remult.user!.organizationId!,
          },
        },
      },
    });
    allow(Roles.Manager, (entity) =>
      remult.user!.managingTeams!.includes(entity.teamId),
    );
  },
};
